import styled, {css} from "@yb/styled-px2rem";

const TableTitleWrap = styled.div`
	position: relative;
	margin: 30px 15px 15px;
`;

const TableTItle = styled.h4`
	// width: 100%;
	font-size: 18px;
	font-weight: bold;
	color: var(--emp-color);
`;

const TableSubTItle = styled.h3`
	font-size: 16px;
	font-weight: bold;
	color: var(--emp-color);
`;

const Table = styled.table<{types?: "basic" | "vertical"}>`
	width: 100%;
	border-top: 1px solid var(--emp-color);

	th,
	td {
		font-size: 15px;
	}

	th {
		padding: 15px 10px 15px 15px;
		border-bottom: 1px solid var(--line-color);
		background: var(--disabled-color);
		line-height: 23px;
		font-weight: bold;
		color: var(--emp-color);
		text-align: left;
	}

	td {
		padding: 15px 15px 15px 10px;
		border-bottom: 1px solid var(--line-color);
		background: #fff;
		line-height: 23px;
		text-align: left;
	}

	${props =>
		props.types === "vertical"
			? css`
					th {
						border-bottom: 0;
					}
					td,
					th {
						&:not(:last-child) {
							border-right: 1px solid var(--line-color);
						}
					}
			  `
			: ""}
`;

export {TableTitleWrap, TableTItle, Table, TableSubTItle};
